import {memo} from 'react';
import {NearbyOptionItem} from '@/map/@types';
import {OverlayLoadFunc} from '@/map/modules';
import {palette} from '@/styles';
import {IRoundColorMarkerProps, RoundColorMarker} from '../RoundColorMarker';

interface IProps extends Omit<IRoundColorMarkerProps, 'contentInfo'> {
  config: naver.maps.MarkerOptions & {
    onLoaded?: OverlayLoadFunc['onLoaded'];
  };
  typeInfo: NearbyOptionItem;
}

export const NearbyInfoMarker = memo(({typeInfo, ...props}: IProps) => {
  return (
    <RoundColorMarker
      contentInfo={{
        icon: typeInfo?.icon,
        color: typeInfo?.color,
        name: typeInfo?.iconicStr ?? typeInfo?.label,
        border: `solid 1px ${palette.white}`,
      }}
      {...props}
    />
  );
});
